import * as Actions from "store/actions/app/establishment.action"
import { addOrUpdateObjectInArray } from "utils/add-or-update-object-in-array"
import { toggleIdInArray } from "utils/toggle-id-in-array"

const initialState = {

  loading_establishment: false,
  establishment: null,

  loading_crud_establishment: false,
  crud_establishment: false,

  loading_branches: false,
  branches: null,

  loading_crud_branch: false,
  crud_branch: false,

  loading_options_by_branch: false,
  options_by_branch: null,

  loading_crud_branch_option: false,
  crud_branch_option: false,

  loading_bank_accounts: false,
  bank_accounts: [],

  saving_bank_account: false,
  saved_bank_account: false,

  deleting_bank_account_ids: [],
  deleted_bank_account_ids: [],
}

const establishment = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_ESTABLISHMENT: {
      return {
        ...state,
        loading_establishment: action.payload.loading,
        establishment: action.payload.data ?? state.establishment,
      }
    }
    case Actions.CRUD_ESTABLISHMENT: {
      return {
        ...state,
        loading_crud_establishment: action.payload.loading,
        crud_establishment: action.payload.crud,
      }
    }
    case Actions.GET_BRANCHES: {
      return {
        ...state,
        loading_branches: action.payload.loading,
        branches: action.payload.data ?? state.branches,
      }
    }
    case Actions.CRUD_BRANCH: {
      return {
        ...state,
        loading_crud_branch: action.payload.loading,
        crud_branch: action.payload.crud,
      }
    }
    case Actions.GET_OPTIONS_BY_BRANCH: {
      return {
        ...state,
        loading_options_by_branch: action.payload.loading,
        options_by_branch: action.payload.data,
      }
    }
    case Actions.CRUD_BRANCH_OPTION: {
      return {
        ...state,
        loading_crud_branch_option: action.payload.loading,
        crud_branch_option: action.payload.crud,
      }
    }
    case Actions.GET_BANK_ACCOUNTS: {
      return {
        ...state,
        loading_bank_accounts: action.payload.loading,
        bank_accounts: action.payload.data ?? state.bank_accounts,
      }
    }
    case Actions.SAVE_BANK_ACCOUNT: {
      return {
        ...state,
        saving_bank_account: action.payload.saving ?? state.saving_bank_account,
        saved_bank_account: action.payload.saved ?? state.saved_bank_account,
        bank_accounts: action.payload.data
          ? addOrUpdateObjectInArray(state.bank_accounts, action.payload.data, 'cuenta_bancaria_id', true)
          : state.bank_accounts,
      }
    }
    case Actions.DELETE_BANK_ACCOUNT: {
      return {
        ...state,
        deleting_bank_account_ids: toggleIdInArray(state.deleting_bank_account_ids, action.payload.deleting_id),
        deleted_bank_account_ids: toggleIdInArray(state.deleted_bank_account_ids, action.payload.deleted_id),
        bank_accounts: state.bank_accounts.filter(item => item.cuenta_bancaria_id !== action.payload.deleted_id)
      }
    }
    default: {
      return state
    }
  }
}
export default establishment
